import { S as Swiper } from './index-Cj6iU7wg.js';
import './swiper-core-kdoF3145.js';
import './classes-to-selector-JYvn0qt6.js';

class RecommendedProducts extends HTMLElement {
  scrollbar = this.dataset.scrollbar === 'true';
  modules = [];

  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.limit = this.dataset.limit;
    this.sectionId = this.dataset.sectionId;
    this.intent = this.dataset.intent;
  }

  async connectedCallback() {
    await this.fetchRecommendations();
    await this.loadModules();
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = Swiper(this, {
      modules: this.modules,
      slidesPerView: 2.22,
      spaceBetween: 16,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        hide: false,
        enabled: true,
        dragSize: 'auto',
        dragClass: 'swiper-scrollbar-drag',
      },
      breakpoints: {
        768: {
          slidesPerView: 4.29,
        },
        1440: {
          spaceBetween: 24,
          slidesPerView: 4.64,
        },
      },
    });
  }

  async loadModules() {
    if (this.scrollbar) {
      const { Scrollbar } = await import('./index-DHebtvlb.js');
      this.modules.push(Scrollbar);
    }
  }

  async fetchRecommendations() {
    await fetch(
      `${window?.Shopify?.routes?.root}recommendations/products?product_id=${this.productId}&limit=${this.limit}&section_id=${this.sectionId}&intent=${this.intent}`
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('recommended-products');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      });
  }
}

customElements.define('recommended-products', RecommendedProducts);
